// extracted by mini-css-extract-plugin
module.exports = {"navTitle":"Navbar_navTitle__Ujfzs","jobTitle":"Navbar_jobTitle__1oknh","name":"Navbar_name__oSfx3"};